<wlm-icon
  *ngIf="!isButton"
  [icon]="'circle'"
  [color]="color"
  [matTooltip]="tooltipKey | translate | lowercase"
></wlm-icon>

<button *ngIf="isButton" (click)="checkhello()">
  <wlm-icon
    [icon]="'circle'"
    [color]="color"
    [matTooltip]="tooltipKey | translate | lowercase"
  ></wlm-icon>
</button>
